const KEY = "ff_session_v1";
const CACHE = "ff_cache_v1";

export const PIN_COLORS = ["#3B82F6", "#EC4899", "#EAB308", "#22C55E", "#A855F7", "#F97316", "#06B6D4", "#EF4444"];
export const PIN_EMOJIS = ["", "🎉", "🕺", "💃", "🎸", "🍺", "🌈", "🔥", "⭐", "🦄", "🍕", "😎"];

function uid() {
  return "u_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
}

export function getSession() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveSession({ name, groupCode }) {
  const existing = getSession();
  const session = {
    userId: existing?.userId || uid(),
    color: existing?.color || PIN_COLORS[Math.floor(Math.random() * PIN_COLORS.length)],
    emoji: existing?.emoji || "",
    name: name.trim(),
    groupCode: groupCode.trim().toUpperCase(),
  };
  localStorage.setItem(KEY, JSON.stringify(session));
  return session;
}

export function persistSession(session) {
  localStorage.setItem(KEY, JSON.stringify(session));
  return session;
}

export function clearSession() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(CACHE);
}

// Offline fallback: cache the last successful members payload + my last position
export function cacheState(state) {
  try {
    localStorage.setItem(CACHE, JSON.stringify(state));
  } catch {}
}

export function readCache() {
  try {
    const raw = localStorage.getItem(CACHE);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
